import { FileText, CheckCircle, XCircle } from "lucide-react";

const ProcessModal = ({
  t,
  styles,
  screenSize,
  isLoading,
  selectedRequest,
  comments,
  setComments,
  theme,
  canApproveDocuments,
  canRejectDocuments,
  onApprove,
  onReject,
  onClose,
}) => {
  return (
    <div style={styles.modal} onClick={() => !isLoading && onClose()}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h3 style={styles.modalTitle}>
          <FileText size={screenSize.isMobile ? 18 : 20} />
          {t.processDocumentRequest}
        </h3>

        <label style={styles.formLabel}>{t.addComments}</label>
        <textarea
          placeholder={t.addCommentsPlaceholder}
          value={comments}
          onChange={(e) => setComments(e.target.value)}
          style={styles.textarea}
          disabled={isLoading}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = "#2e7cba";
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor =
              theme === "light" ? "#e2e8f0" : "rgba(255, 255, 255, 0.2)";
          }}
        />

        <div style={styles.buttonGroup}>
          {canRejectDocuments && (
            <button
              style={styles.secondaryButton}
              onClick={() => onReject(selectedRequest?.id)}
              disabled={isLoading}
            >
              <XCircle size={16} />
              {t.reject}
            </button>
          )}

          {canApproveDocuments && (
            <button
              style={styles.button}
              onClick={() => onApprove(selectedRequest?.id)}
              disabled={isLoading}
            >
              <CheckCircle size={16} />
              {isLoading
                ? t.processing
                : selectedRequest?.requestType?.startsWith("upload:")
                  ? t.approveUpload
                  : t.approveGenerate}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProcessModal;